/* eslint-disable import/no-unresolved */
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CREATE_CLASSIFY_AUDIT_LOG_FOR_METRO2 } from 'Apollo/Mutations/Rules/Metro2';
import ClassifyResultModal from '../../common/ClassifyResultModal';

const Metro2ClassifyResult = ({
    setShowClassifyResult, refetch, refetchTestData,
}) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);

    const [comment, setComment] = useState('');
    const [radio, setRadio] = useState('MARK_AS_REVIEW_REQUIRED');
    const [showLoader, setShowLoader] = useState(false);

    /* Apollo mutation to update the comment */
    const [updateComment] = useMutation(
        CREATE_CLASSIFY_AUDIT_LOG_FOR_METRO2,
        {
            variables: {
                input: {
                    comment,
                    batchId: Number(batchId),
                    eventName: radio,
                    ruleId: Number(ruleId),
                },
            },
        },
    );

    /* Calls updateComment(), refetches the failed test and audit logs data  */
    const onClickMetro2Classify = async () => {
        setShowLoader(true);
        await updateComment();
        setComment('');
        setShowLoader(false);
        refetch();
        refetchTestData();
        setShowClassifyResult(false);
    };

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <ClassifyResultModal
            onClickClassify={onClickMetro2Classify}
            showLoader={showLoader}
            comment={comment}
            setComment={setComment}
            radio={radio}
            setRadio={setRadio}
            setShowClassifyResult={setShowClassifyResult}
        />
    );
};

export default Metro2ClassifyResult;
